import React, { Component } from "react";
import { Container, Card } from "react-bootstrap";
import ApiService from "../../../_services/ApiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft,faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import Config from "../../../_config/config"
import { ILoader } from "../../../_components/iloader/iloader"
import './viewTestSubmission.css'

class SubmitTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      question: '',
      answer: '',
    }
  }

  showAlert() {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = Config.CONNECTION_ERROR_MSG;
    swal({
      content: wrapper,
      icon: "warning",
      button: "Ok",
      allowOutsideClick: false,
      closeOnClickOutside: false,
      className: "orange-card",
    }).then((willDelete) => {
      if (willDelete) {
        window.location.reload();
      }
    });
  }

  renderLoader = () => {
    const _loadingText = "Please wait...";
    return (
      <ILoader
        loadingText={_loadingText}
        isShow={this.state.showLoading}
      ></ILoader>
    );
  };

  closeWin() {
    window.opener?.location?.reload();
    window.close();
  }

  componentDidMount() {
    this.setState({ showLoading: true }, () => {
      ApiService.getTestSubmission(this.props.match.params.id)
        .then((res) => {
          this.setState({
            question: res.data?.questionStatement.replace('Write Your Story Here', "Here's your story"),
            answer: res.data?.textAnswer,
            showLoading: false
          })
        })
        .catch((err) => {
          this.setState({
            showLoading: false,
          });
          this.showAlert();
          console.log(err, err.stack); // an error occurred
        });
    });
  }

  render() {
    let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
    return (
      <Container id="container" fluid>
        <div className={`module-header-step2 ${portlet.class ? portlet.class : "orange-card"}`}>
          <div className="back">
            <FontAwesomeIcon
              icon={this.props.location?.state?.button =="back" ? faArrowLeft : faTimesCircle}
              onClick={() => this.props.location?.state?.button =="back" ? this.props.history.goBack() : this.closeWin()}
            />
          </div>
          <h4>
            {this.props.location?.state?.title || "Your Submission"}
          </h4>
        </div>
        <div dangerouslySetInnerHTML={{ __html: this.state.question }}></div>
        <div className="story_answer" dangerouslySetInnerHTML={{ __html: this.state.answer }}></div>
        {this.renderLoader()}
      </Container>
    )
  }
}

export default SubmitTest;

